import { render, staticRenderFns } from "./create-survey.component.html?vue&type=template&id=6304c280&scoped=true&"
import script from "./create-survey.component.ts?vue&type=script&lang=ts&"
export * from "./create-survey.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-survey.component.scss?vue&type=style&index=0&id=6304c280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304c280",
  null
  
)

export default component.exports